import systemConfig from '../utils/systemConfig'
import config from '../config'

export default {
  // 系统配置参数
  ...systemConfig,
  token: state => state.user.token,
  dict: state => {
    const dictObj = (state.app.dict[`value_${state.i18n.locale}`] || {}).data || {}
    if (config.platform === 'RIVER') {
      return {
        ...dictObj,
        TradeOrderDirectionEnum: {
          ...dictObj.TradeOrderDirectionEnum,
          '1': 'More',
          '2': 'Short'
        }
      }
    } else {
      return dictObj
    }
  },
  vcList: state => (state.vc.vcList[`value_${state.i18n.locale}`] || {}).data || [],
  vcListNoSettleEnabled: (state, getters) => getters.vcList.filter(item => !item['settleVc'] && item.enabled),
  vcListEnabled: (state, getters) => getters.vcList.filter(item => item.enabled),
  cacheInfo: state => state.app.cacheInfo || {},
  locale: state => state.i18n.locale,
  vcId: state => state.vc.vcId,
  currentLocale: state => state.app.currentLocale,
  tradeConfig: state => (state.vc.tradeConfig[`value_${state.i18n.locale}`] || {}).data || [],
  localeList: state => state.app.localeList.value
}



// WEBPACK FOOTER //
// ./src/store/getters.js